import { useEffect, useState } from "react";
import { Twitch } from "lucide-react";
import api from "@/lib/api";

// liveOnly : version accueil, n'affiche que les chaînes en direct (rien si personne n'est en live)
export default function Streamers({ liveOnly = false, className = "mt-10" }) {
  const [channels, setChannels] = useState([]);
  const [live, setLive] = useState([]);
  const [active, setActive] = useState("");

  useEffect(() => {
    api.get("/streamers").then((r) => {
      const { channels: all, live: on } = r.data;
      // Les chaînes en direct passent devant, dans l'ordre choisi en admin
      const sorted = [...all.filter((c) => on.includes(c)), ...(liveOnly ? [] : all.filter((c) => !on.includes(c)))];
      setChannels(sorted);
      setLive(on);
      setActive(sorted[0] || "");
    }).catch(() => {});
  }, [liveOnly]);

  if (channels.length === 0) return null;

  // Twitch exige le domaine exact de la page dans "parent"
  const src = `https://player.twitch.tv/?channel=${encodeURIComponent(active)}&parent=${window.location.hostname}&muted=true`;

  return (
    <section data-testid={liveOnly ? "home-live-section" : "streamers-section"} className={className}>
      <p className="text-xs font-bold uppercase tracking-[0.2em] text-orange-500">
        {live.length > 0 ? `${live.length} en direct` : "Hors ligne pour le moment"}
      </p>
      <h2 className="mt-2 text-2xl font-extrabold uppercase tracking-tight sm:text-3xl">{liveOnly ? "En direct maintenant" : "Streamers"}</h2>

      <div className="mt-6 flex flex-wrap gap-3">
        {channels.map((c) => (
          <button key={c} onClick={() => setActive(c)} data-testid={`streamer-${c}`} aria-pressed={active === c}
            className={`flex items-center gap-2 rounded-lg border px-4 py-2 font-heading text-sm font-bold uppercase tracking-wide transition-all ${
              active === c ? "border-orange-500 bg-orange-500 text-[#060B18]" : "border-orange-500/30 text-slate-300 hover:bg-orange-500/10"
            }`}>
            <Twitch className="h-4 w-4" /> {c}
            {live.includes(c) && (
              <span data-testid={`streamer-live-${c}`} className="flex items-center gap-1 rounded bg-red-600 px-1.5 py-0.5 text-[10px] text-white">
                <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-white" /> Live
              </span>
            )}
          </button>
        ))}
      </div>

      <div className="card-tactical mt-6 max-w-2xl overflow-hidden p-0">
        <iframe key={active} src={src} title={`Chaîne Twitch de ${active}`} data-testid="streamer-player"
          allowFullScreen className="aspect-video w-full" />
      </div>
      <a href={`https://www.twitch.tv/${active}`} target="_blank" rel="noopener noreferrer"
        className="mt-3 inline-flex min-h-[44px] items-center text-xs font-bold uppercase tracking-widest text-orange-400 hover:text-orange-300">
        Ouvrir sur Twitch
      </a>
    </section>
  );
}
